import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const FaqPage = () => {
  return (
    <div>
      <h1 style={{ marginTop: "0px" }}>FAQ</h1>
      <h3>
        <b>What is the Big Brother Stock Exchange?</b>
      </h3>
      <p>
        The Big Brother Stock Exchange is a simulation of the stock market for
        Big Brother players throughout the season. A player’s value with rise
        and fall based on the demand.
      </p>
      <h3>
        <b>What happens when a player is eliminated?</b>
      </h3>
      <p>
        When a player is eliminated, their stock price will become $0 and they
        will no longer be able to be purchased.
      </p>
      <h3>
        <b>How does the game end?</b>
      </h3>
      <p>
        When a player wins the season, their stock price will become $10 and all
        user stocks will automatically be sold.
      </p>
      <h3>
        <b>How do I get more money?</b>
      </h3>
      <p>
        You will start with $100 to spend on player stocks. Each week, you will
        receive an additional $20. To get more cash, you can sell your remaining
        stocks.
      </p>
      <h3>
        <b>Do I have to spend all my money?</b>
      </h3>
      <p>
        You can purchase stocks at any time. You can also hold on your cash for
        a better time to buy.
      </p>
      <h3>
        <b>How does the leaderboard work?</b>
      </h3>
      <p>
        All users will be ranked on the leaderboard based on their total value
        of all assets. The total value is calculated using the user’s cash and
        the value of their stocks.
      </p>
      <h3>
        <b>Why can’t I buy right now?</b>
      </h3>
      <p>
        The stock exchange is open 24/7 except for during the live eviction
        episode.
      </p>
    </div>
  );
};

export default FaqPage;
